import { PageShell, PageHero } from "@/components/site/page-shell";

export type LegalSection = { heading: string; body: string };

export function LegalPage({
  eyebrow,
  title,
  sub,
  updated,
  sections,
}: {
  eyebrow: string;
  title: string;
  sub: string;
  updated: string;
  sections: LegalSection[];
}) {
  return (
    <PageShell>
      <PageHero eyebrow={eyebrow} title={title} sub={sub} />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl px-4 lg:px-8">
          <div className="mb-8 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            Last updated: {updated}
          </div>
          <div className="space-y-8">
            {sections.map((s) => (
              <div key={s.heading} className="rounded-2xl border border-border bg-card p-6 shadow-card">
                <h2 className="text-lg font-semibold">{s.heading}</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground whitespace-pre-line">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
